import axios from 'axios';


export function createWorkCard(formData, user_profile_id, authenticityToken) {
  const API_URL = `/panel/${user_profile_id}/karty-pracy`;

  return axios({
    method: 'post',
    url: API_URL,
    data: formData,
    headers: {
      "X-CSRF-Token": authenticityToken
    },
    config: { headers: {'Content-Type': 'multipart/form-data' }}
  });
}

export function updateWorkCard(formData, work_card_id, user_profile_id, authenticityToken) {
  const API_URL = `/panel/${user_profile_id}/karty-pracy/${work_card_id}`;

  return axios({
    method: 'patch',
    url: API_URL,
    data: formData,
    headers: {
      "X-CSRF-Token": authenticityToken
    },
    config: { headers: {'Content-Type': 'multipart/form-data' }}
  });
}
